import { render, staticRenderFns } from "./confirmNewPassword.vue?vue&type=template&id=3b0c2e60"
import script from "./confirmNewPassword.vue?vue&type=script&lang=js"
export * from "./confirmNewPassword.vue?vue&type=script&lang=js"
import style0 from "./confirmNewPassword.vue?vue&type=style&index=0&id=3b0c2e60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports